import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-node-col card-gap text-left" }
const _hoisted_2 = { class: "flex-item-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!
  const _component_stack_layout = _resolveComponent("stack-layout")!
  const _component_my_grid = _resolveComponent("my-grid")!
  const _component_portal_page = _resolveComponent("portal-page")!
  const _component_loader_guard = _resolveComponent("loader-guard")!

  return (_openBlock(), _createBlock(_component_loader_guard, {
    "has-loaded": _ctx.data != null
  }, {
    default: _withCtx(() => [
      _createVNode(_component_portal_page, {
        title: _ctx.pageTitle,
        "show-log-off": true,
        "show-back-button": true,
        container: "admin"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_stack_layout, {
              orientation: "horizontal",
              gap: 8
            }, {
              default: _withCtx(() => [
                _createVNode(_component_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_header, { class: "k-hstack section" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('equipmentNo')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card_body, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.data.equipmentNo), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_header, { class: "k-hstack section" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('serialNo')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card_body, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.data.serialNo), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_header, { class: "k-hstack section" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('description')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card_body, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.data.description), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_header, { class: "k-hstack section" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('productionOrderNo')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card_body, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.data.productionOrderNo), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_card_header, { class: "k-hstack section" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.localize('warnings')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card_body, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_my_grid, {
                        data: _ctx.warnings,
                        columns: _ctx.columns,
                        "initial-sort": _ctx.initialSort,
                        filterable: true
                      }, null, 8, ["data", "columns", "initial-sort"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }, 8, ["has-loaded"]))
}